import VideoSlide from 'components/logistics/stats/video';
import React from 'react';

const LogisticsStatsPageSeven = () => {
  return <VideoSlide />;
};
export default LogisticsStatsPageSeven;
